import { SelectBase } from './SelectBase'
import getServiceRequestsStatuses from '~/api/getServiceRequestsStatuses'
import { Modal } from '~/4trend/Modal'
import { InputBase_v2 } from './InputBase_v2'
import { ButtonBase } from './Buttons/ButtonBase'

/**
 * @typedef SelectStatusData
 * @property {import('~/api/getServiceRequestsStatuses').Status} selected
 * @property {import('~/api/getServiceRequestsStatuses').Status[]} statuses
 * @property {string} reject
 */

/**
 * @typedef SelectStatusProps
 * @property {string|number} [value]
 * @property {string} [name]
 * @property {boolean} [required]
 */

/**
 * @typedef SelectStatusComputed
 * @property {import('~/api/getServiceRequestsStatuses').Status[]} filteredStatuses
 */

/**
 * @typedef SelectStatusMethods
 * @property {(id: string) => void} setSelectedById
 * @property {(id: string) => boolean} eqSelected
 * @property {(value: string) => void} setReject
 */

/** @typedef {import('vue/types/options').ThisTypedComponentOptionsWithRecordProps<{}, SelectStatusData, SelectStatusMethods, SelectStatusComputed, SelectStatusProps>} SelectStatusComponent */

/** @type {SelectStatusComponent} */
const SelectStatus = {
	props: {
		value: [String, Number],
		name: String,
		required: Boolean,
	},
	data: (vm) => ({
		selected: {
			ID: vm.value
		},
		statuses: [],
		reject: '',
	}),
	computed: {
		filteredStatuses: (vm) => vm.statuses.filter(status => !status.HIDE_ON_DETAIL)
	},
	methods: {
		eqSelected(value) {
			return this.selected.ID == value
		},
		setReject(value) {
			this.reject = value
		},
		setSelectedById(id) {
			this.$options.preservedSelected = this.selected
			this.selected = this.statuses.find((status) => status.ID === id)

			if (this.selected.HAS_MODAL)
				this.$refs.modal?.show()
			else
				this.$refs.select?.$refs?.select?.form?.submit()
		},
	},
	mounted() {
		getServiceRequestsStatuses().then(statuses => this.statuses = statuses)
	},
	render(h) {
		return (
			<div>
				<SelectBase
					ref="select"
					name={ this.name }
					required={ this.required }
					vOn:change={ (event) => this.setSelectedById(event.currentTarget.value) }
				>
					{ this.statuses.map(status => (
						<option
							selected={ this.eqSelected(status.ID) }
							value={ status.ID }
						>
							{ status.NAME }
						</option>
					)) }
				</SelectBase>
				<Modal
					ref="modal"
					title="Отказано в гарантии по причине"
					vOn:hide={ () => this.selected = this.$options.preservedSelected }
				>
					<InputBase_v2
						class="mb-2"
						type="textarea"
						name="NO_REPAIR_REASON"
						label="Причина отказа"
						value={ this.reject }
						vOn:input={ (value) => this.setReject(value) }
					/>
					<ButtonBase class="button button_theme_secondary" type="submit">
						Сохранить
					</ButtonBase>
				</Modal>
			</div>
		)
	},
}

export default SelectStatus

